import localforage from 'localforage';
import { getAllRegisteredStores, registerStore } from './offlineStoreRegistry';

/**
 * Runs once on app startup. Finds any sync_backup keys left by a crashed sync,
 * moves missing ops into orphaned_ops for user review, then returns all stores
 * that have orphaned ops waiting (whether just found or from a previous session).
 *
 * Returns: Array<{ storeName: string, operations: Array }>
 */
export const recoverOrphanedSyncBackups = async () => {
  const result = [];

  try {
    const stores = await getAllRegisteredStores();

    for (const { storeName } of stores) {
      try {
        const operationStore = localforage.createInstance({
          name: `OfflineOperations_${storeName}`,
        });

        const backup = await operationStore.getItem('sync_backup');

        if (backup && backup.length > 0) {
          const current = (await operationStore.getItem('operations')) || [];
          const currentIds = new Set(current.map((op) => op.id));
          const missing = backup.filter((op) => !currentIds.has(op.id));

          if (missing.length > 0) {
            const existing = (await operationStore.getItem('orphaned_ops')) || [];
            const existingIds = new Set(existing.map((op) => op.id));
            const newOrphans = missing.filter((op) => !existingIds.has(op.id));
            if (newOrphans.length > 0) {
              await operationStore.setItem('orphaned_ops', [...existing, ...newOrphans]);
              console.warn(`[SyncRecovery] Found ${newOrphans.length} orphaned ops in "${storeName}"`);
            }
          }

          await operationStore.removeItem('sync_backup');
        }

        const orphaned = await operationStore.getItem('orphaned_ops');
        if (orphaned && orphaned.length > 0) {
          result.push({ storeName, operations: orphaned });
        }
      } catch (err) {
        console.error(`[SyncRecovery] Failed to check store "${storeName}":`, err);
      }
    }
  } catch (err) {
    console.error('[SyncRecovery] Recovery pass failed:', err);
  }

  try {
    const visitsStore = localforage.createInstance({ name: 'OfflineOperations_visits' });
    const visitsOps = await visitsStore.getItem('operations');
    if (Array.isArray(visitsOps) && visitsOps.length > 0) {
      await registerStore('visits', '/customer-action');
    }
  } catch (err) {
    console.error('[SyncRecovery] Failed to check visits store:', err);
  }

  return result;
};
